import {Action} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";
import {log} from "@dp-instant/utils";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {inject, injectable} from "inversify";

@injectable()
export class TournamentPostScoreAction extends Action<void> {
    @inject(TypesGame.model)
    private readonly model: GameModel;

    @inject(TypesSocial.model)
    private readonly social: ISocial;

    async execute(): Promise<void> {
        if (this.social.socialPlatform !== "fb") {
            return;
        }

        const continent = this.model.currentContinent;

        window.FBInstant.tournament
            .postScoreAsync(continent.getTotalScore())
            //@ts-ignore
            .catch(e => log.warn("FBInstant.tournament.postScoreAsync", e));
    }
}
